import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const HomeIcon = ({
  color = 'foraBlue',
  width = 16,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M15.673 6.596L8.64.247c-.365-.33-.914-.33-1.28 0L.327 6.597c-.665.6-.248 1.72.64 1.72h1.68V14h3.23v-3.712h4.246V14h3.23V8.317h1.679c.889 0 1.306-1.12.64-1.72"
      />
    </svg>
  </DefaultIconWrapper>
);
